import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { TabViewModule } from 'primeng/tabview';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DividerModule } from 'primeng/divider';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DataViewModule } from 'primeng/dataview';
import { ImageModule } from 'primeng/image';
import { FileUploadModule } from 'primeng/fileupload';
import { ChartModule } from 'primeng/chart';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TreeTableModule } from 'primeng/treetable';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { LoaderComponent } from '../components/loader/loader.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { StimulsoftViewerModule } from 'stimulsoft-viewer-angular';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LoaderComponent
  ],
  exports: [
    CardModule,
    ButtonModule,
    InputTextModule,
    CheckboxModule,
    FormsModule, 
    ReactiveFormsModule,
    PanelMenuModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    OverlayPanelModule,
    DropdownModule,
    ToastModule,
    TableModule,
    RadioButtonModule,
    InputNumberModule,
    TabViewModule,
    DynamicDialogModule,
    DividerModule,
    InputTextareaModule,
    DataViewModule,
    ImageModule,
    FileUploadModule,
    ChartModule,
    AutoCompleteModule,
    ConfirmDialogModule,
    TreeTableModule,
    DialogModule,
    CalendarModule,
    LoaderComponent,
    BreadcrumbModule,
    StimulsoftViewerModule,
    TieredMenuModule,
    FullCalendarModule,
    TooltipModule,
    MenuModule,

  ],
  providers:[MessageService,DialogService,DynamicDialogRef,ConfirmationService]
})
export class SharedModule { }
